import { AuthToken } from '@dock/types-dock-partner';

import { isDateExpired } from './isDateExpired';

export const commonBL = {
    isTokenExpired: (token?: AuthToken | undefined): boolean =>
        !token || isDateExpired(token?.datetimes?.expires),
};
